import { DatoSeleccion } from '@/models/componentes/select.model';

export const crearComboSeleccion = <T, Kn extends keyof T, Kv extends keyof T>(
  datos: T[],
  propNombre: Kn,
  propValor: Kv
): DatoSeleccion[] => {
  if (datos.length > 0) {
    return datos.map((d) => {
      const nombre = d[propNombre];
      const valor = d[propValor];

      // Asegurando que los valores sean del tipo correcto
      if (
        typeof nombre === 'string' &&
        (typeof valor === 'string' || typeof valor === 'number')
      ) {
        return {
          nombre: nombre as string,
          valor: valor as string | number,
        };
      }

      // Manejo de error si los tipos no son los esperados
      throw new Error(
        'Los tipos de las propiedades no coinciden con DatoSeleccion'
      );
    });
  }
  return [] as DatoSeleccion[];
};
